import { contactUsCards } from "../../../../src/pages/foundations/accessibility/_contact";
import { IconCardGroup } from '@af/design-system-docs-ui';
import * as React from 'react';
export default {
  contactUsCards,
  IconCardGroup,
  React
};